import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-med-reim-sanction-form',
  templateUrl: './med-reim-sanction-form.component.html',
  styleUrls: ['./med-reim-sanction-form.component.css']
})
export class MedReimSanctionFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/employee-claims/med-reim-sanction/med-reim-sanction-form/med-reim-sanction-form.component.ts